import { CurrencyEnum, CurrencyExchange } from "@finway-group/shared/lib/models"
import axios from "axios"
import moment from "moment-timezone"
import store from "~Shared/store"
import { getExchangeConversionFactor } from "~Shared/utils/helper.utils"

const MODEL = "currency"

const CurrencyService = {
    fetchCurrencyExchange: async (currencyExchangeId?: string, date?: moment.Moment) => {
        const params: Record<string, string> = {}
        if (currencyExchangeId) {
            params.id = currencyExchangeId
        }
        if (date) {
            params.date = date.format("YYYY-MM-DD")
        }

        const { data } = await axios.get(`/${MODEL}/exchange`, { params })
        return data as CurrencyExchange
    },
    convert: (value: number, sourceCurrency: CurrencyEnum, destCurrency: CurrencyEnum, precision: number = 2, currencyExchange?: CurrencyExchange) => {
        let result = value

        if (sourceCurrency === destCurrency) {
            return value
        }

        // convert to base currency if we need to
        if (sourceCurrency !== CurrencyEnum.USD) {
            let sourceFactor: undefined | number
            if (currencyExchange) {
                sourceFactor = getExchangeConversionFactor(currencyExchange, sourceCurrency)
            }
            if (!sourceFactor) {
                sourceFactor = CurrencyService.getConversionFactor(sourceCurrency)
            }
            result /= sourceFactor
        }
        // convert to dest currency
        if (destCurrency !== CurrencyEnum.USD) {
            let destFactor: undefined | number
            if (currencyExchange) {
                destFactor = getExchangeConversionFactor(currencyExchange, destCurrency)
            }
            if (!destFactor) {
                destFactor = CurrencyService.getConversionFactor(destCurrency)
            }
            result *= destFactor
        }

        return Number(result.toFixed(precision))
    },
    getConversionFactor: (currency: CurrencyEnum): number => {
        const exchange = store.getState().currency.item as CurrencyExchange
        const rate = getExchangeConversionFactor(exchange, currency)
        if (!rate) {
            throw new Error(`Cannot get conversion factor for currency ${currency}`)
        }

        return rate
    },
}

export default CurrencyService
